import { Chip } from 'components/ui';
import { FormattedMessage } from 'react-intl';

const ROLE_COLORS = {
  owner: 'success',
  admin: 'info',
  inspector: 'warning',
  viewer: 'default',
};

const Role = ({ role }) => {
  if (!role) return null;

  return (
    <Chip
      size="small"
      color={ROLE_COLORS[role] ?? 'default'}
      label={<FormattedMessage id={`role.name.${role}`} />}
    />
  );
};

export default Role;
